<script lang="ts" setup>
// @ts-expect-error JS library
import { useMq } from 'vue3-mq'
import { LordIconSource, LordIconTrigger, Iconify } from '~/types/assets'
import type { LordIcon } from '~/types/assets'
import { useLocaleThemePath } from '~/composables/locale'

const { xs } = useMq()

const globe: LordIcon = {
  src: LordIconSource.globe,
  trigger: LordIconTrigger.loop,
  loading: 'lazy',
  revert: false,
  delay: 4000,
  size: xs ? 50 : 85
}
</script>

<template lang="pug">
KinesisContainer.media__beta(
  tag="section"
)
  KinesisElement(:strength="75")
    IconLord(v-bind="globe")
  KinesisElement.text-primary(
    :strength="50"
    tag="h2"
  ) {{ $t('media.beta.title') }}
  KinesisElement(
    :strength="25"
    tag="p"
  ) {{ $t('media.beta.subtitle') }}
  KinesisElement.media__beta__schema(
    :strength="50"
  )
    Icon(:name="Iconify?.vimeo")
    Icon(:name="Iconify?.right")
    Icon(:name="Iconify?.rest")
    Icon(:name="Iconify?.right")
    Icon(:name="Iconify?.sqlite")
    Icon(:name="Iconify?.right")
    Icon(:name="Iconify?.rest")
    Icon(:name="Iconify?.right")
    Icon(:name="Iconify?.contacts")
  KinesisElement(
    tag="a"
    href="https://developer.vimeo.com/api/guides/start"
    target="_blank"
    rel="nofollow"
    :strength="25"
  ) {{ $t('media.beta.anchor') }}
  KinesisElement(
    tag="aside"
    :strength="25"
  )
    p {{ $t('media.beta.aside.0') }}
      a(
        href="https://www.npmjs.com/package/vimeo"
        rel="nofollow"
        target="_blank"
        :title="$t('media.beta.anchors.vimeo.title')"
        :aria-label="$t('media.beta.anchors.vimeo.aria-label')"
      ) {{ $t('media.beta.anchors.vimeo.label') }}.
    p {{ $t('media.beta.aside.1') }}
  KinesisElement(:strength="25")
    UIButton(class-name="bg-secondary text-dark-900 hover:bg-dark-800 hover:text-primary mt-4")
      NuxtLink.w-full.h-full(
        :to="`${useLocaleThemePath('/portfolio')}#gamma-section`"
        :title="$t('media.beta.anchors.seeding.title')"
        :aria-label="$t('media.beta.anchors.seeding.aria-label')"
      ) {{ $t('media.beta.button') }}
</template>

<style lang="sass" scoped>
.media__beta
  @apply w-full h-full flex-center flex-col
  h2
    @apply text-3xl lg:text-4xl text-white text-center mt-4
  p
    @apply text-primary text-center text-base lg:text-2xl py-4 xl:py-10
  .media__beta__schema
    @apply flex items-center lg:gap-8 p-2 lg:p-4 border border-primary rounded-lg bg-[rgba(0,0,0,0.6)]
  a[target="_blank"]
    @apply text-secondary text-lg lg:text-2xl underline cursor-pointer mt-4 xl:mt-10
  aside
    @apply max-w-[800px] text-center lg:mt-6
    p
      @apply text-primary py-0 text-base lg:text-xl xl:text-2xl
    a[target="_blank"]
      @apply text-primary ml-1 text-base lg:text-xl xl:text-2xl
  [class*="i-"]
    @apply text-lg lg:text-3xl
    &:nth-child(odd)
      @apply bg-primary
    &:nth-child(even)
      @apply bg-secondary
</style>
